import {getIdToken} from "../../misc/miscUtils.ts";
import {URL_BASE} from "../../../Globals.ts";

export const writeToChatHistory = async (user: any, isIncognito: boolean, conversationId: string, messagesSequenceRef: any, llmRequestRefs: any) => {
    if (!user || isIncognito) return;

    try {
        const token = await getIdToken(user);

        const messagesSequence = messagesSequenceRef.current;

        let resolvedMediaPromises: any = {};
        const mediaPromises = llmRequestRefs.current.mediaWritePromises;
        if (mediaPromises && Object.keys(mediaPromises).length > 0) {
            const entries = Object.entries(mediaPromises);

            for (const [key, promise] of entries) {
                try {
                    const resolved = await Promise.resolve(promise);
                    if (resolved) resolvedMediaPromises[key] = resolved;
                } catch (error) {
                    console.error(`Failed to resolve image promise for ${key}:`, error);
                }
            }
        }

        llmRequestRefs.current.messagesToWrite.map((message: any) => {
            message.message.content.map((contentItem: any) => {
                if (contentItem.storeAfterUse && contentItem.fileName &&
                    contentItem.fileName in resolvedMediaPromises) {
                    contentItem.fileContent = resolvedMediaPromises[contentItem.fileName];
                }
            })
        });

        const url = `${URL_BASE}/api/writeToChatHistory`;
        const maxRetries = 3;
        const baseDelay = 1000; // 1 second base delay

        for (let attempt = 0; attempt < maxRetries; attempt++) {
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        conversationId: conversationId,
                        newMessages: llmRequestRefs.current.messagesToWrite,
                        parentMessage: llmRequestRefs.current.parentMessage,
                        messagesSequence: messagesSequence
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return; // Success, exit the retry loop
            } catch (error) {
                if (attempt === maxRetries - 1) throw error; // Rethrow on last attempt
                const currentDelay = baseDelay * Math.pow(2, attempt); // Exponential backoff
                console.warn(`Attempt ${attempt + 1} failed, retrying in ${currentDelay}ms...`);
                await new Promise(resolve => setTimeout(resolve, currentDelay));
            }
        }
    } catch (error) {
        console.error(error);
    }
}
